import React from "react";
import { Typography, Tag, Row, Col } from "antd";
import CommonTable from "./CommonTable";
import { capitalizeFirstLetter } from "../../../helpers/utility";
import dayjs from "dayjs";

const customTypography = (title, value) => (
  <>
    <Typography
      style={{
        whiteSpace: "normal",
        wordBreak: "break-word",
        fontWeight: "lighter",
        fontSize: "10px",
      }}
    >
      {title}
    </Typography>
    <Typography
      style={{
        whiteSpace: "normal",
        wordBreak: "break-word",
        fontWeight: "lighter",
        fontSize: title === "Comments" ? "12px" : "14px",
      }}
    >
      {title === "Comments" && value ? (
        <Tag color="blue">
          <Typography
            style={{
              whiteSpace: "normal",
              wordBreak: "break-word",
              fontSize: "12px",
            }}
          >
            {value}
          </Typography>
        </Tag>
      ) : (
        value || "-"
      )}
    </Typography>
  </>
);

const SpecialistConsultation = ({ data }) => {
  const columns = [
    {
      title: "Time Done",
      dataIndex: "process_time",
      render: (value) => (value ? dayjs(value)?.format("DD, MMM hh:mm A") : "-"),
    },
  ];

  return (
    <div>
      {data?.map((item, index) => (
        <CommonTable
          key={index}
          data={item?.actions}
          columns={columns}
          titleData={() => (
            <Row gutter={[12, 12]}>
              <Col span={6}>
                {customTypography(
                  "Specialist",
                  item?.data?.specialist || item?.drug_name
                )}
              </Col>
              <Col span={10}>
                {customTypography("Comments", item?.data?.instructions)}
              </Col>
              <Col span={8}>
                {customTypography(
                  "Advised By",
                  capitalizeFirstLetter(item?.advised_by)
                )}
              </Col>
            </Row>
          )}
        />
      ))}
    </div>
  );
};

export default SpecialistConsultation;
